import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Portfolio from "../pages/portfolio/page";
import Sectors from "../pages/sectors/page";
import InvestorRelations from "../pages/investor-relations/page";
import Contact from "../pages/contact/page";
import Legal from "../pages/legal/page";
import Navbar from "../components/feature/Navbar";
import Footer from "../components/feature/Footer";

function Layout({ children }: { children: React.ReactNode }) {
  return (
    <>
      <Navbar />
      {children}
      <Footer />
    </>
  );
}

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout><Home /></Layout>,
  },
  {
    path: "/about",
    element: <Layout><About /></Layout>,
  },
  {
    path: "/portfolio",
    element: <Layout><Portfolio /></Layout>,
  },
  {
    path: "/sectors",
    element: <Layout><Sectors /></Layout>,
  },
  {
    path: "/investor-relations",
    element: <Layout><InvestorRelations /></Layout>,
  },
  {
    path: "/contact",
    element: <Layout><Contact /></Layout>,
  },
  {
    path: "/legal",
    element: <Layout><Legal /></Layout>,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;